export default {
  methods: {
    nonDiacriticsSensitiveFilter(item, queryText, itemText) {
      return itemText.normalize('NFD').toLocaleLowerCase().replace(/[\u0300-\u036f]/g, '')
        .indexOf(queryText.normalize('NFD').toLocaleLowerCase().replace(/[\u0300-\u036f]/g, '').trim()) > -1;
    },
  },
};
